<template>
  <kst-tooltip
    v-if="row.BuyPrice !== buyPrice"
    position="is-left"
    size="is-medium"
    :type="type"
  >
    <template #content>
      {{ text }}
    </template>

    <span class="icon" :class="iconClass">
      <i :class="icon"/>
    </span>
  </kst-tooltip>
</template>

<script>
import Info from "../ReceiveInfo.js";

export default {
  props: {
    row: Object,
    buyPrice: Number
  },
  computed: {
    buyPriceType() {
      return this.row.BuyPrice > this.buyPrice ? "High" : "Low";
    },
    icon() {
      return Info.PriceSearch.BuyPrice[this.buyPriceType].Icon;
    },
    iconClass() {
      return Info.PriceSearch.BuyPrice[this.buyPriceType].IconClass;
    },
    type() {
      return Info.PriceSearch.BuyPrice[this.buyPriceType].TooltipClass;
    },
    text() {
      return Info.PriceSearch.BuyPrice[this.buyPriceType].TooltipText;
    }
  }
}
</script>